import { ApiUserData } from "src/models/user/ApiUserData"
import { TieupRequestStatus } from "./TieupRequestStatus"

export type RequestedTieupValue = {
  status: TieupRequestStatus
  id: number
  userId: string
  appliedUserId: string
  hasBaseNovel: boolean
  baseNovelTitle: string
  novelId: number | null
  hasIllustration: boolean
  illustrationTitle: string
  illustrationUrl: string
  createdAt: string
  chatId: number
  appliedUser: ApiUserData
  user: ApiUserData
  userRole: number
  appliedUserRole: number
  wantToEliminatedByUser: boolean
  wantToEliminatedByAppliedUser: boolean
  message: string
}

export class RequestedTieup {
  constructor(private value: RequestedTieupValue) {
    // noop
  }

  get status(): TieupRequestStatus {
    return this.value.status
  }

  get id(): number {
    return this.value.id
  }

  get userId(): string {
    return this.value.userId
  }

  get appliedUserId(): string {
    return this.value.appliedUserId
  }

  get hasBaseNovel(): boolean {
    return this.value.hasBaseNovel
  }

  get baseNovelTitle(): string {
    return this.value.baseNovelTitle
  }

  get novelId(): number | null {
    return this.value.novelId
  }

  get hasIllustration(): boolean {
    return this.value.hasIllustration
  }

  get illustrationTitle(): string {
    return this.value.illustrationTitle
  }

  get illustrationUrl(): string {
    return this.value.illustrationUrl
  }

  get createdAt(): string {
    return this.value.createdAt
  }

  get chatId(): number {
    return this.value.chatId
  }

  get appliedUser(): ApiUserData {
    return this.value.appliedUser
  }

  get user(): ApiUserData {
    return this.value.user
  }

  get userRole(): number {
    return this.value.userRole
  }

  get appLiedUserRole(): number {
    return this.value.appliedUserRole
  }

  get wantToEliminatedByUser(): boolean {
    return this.value.wantToEliminatedByUser
  }

  get wantToEliminatedByAppliedUser(): boolean {
    return this.value.wantToEliminatedByAppliedUser
  }

  get message(): string {
    return this.value.message
  }

  collaborator(target: ApiUserData): ApiUserData {
    if (this.userId === target.id) {
      return this.value.appliedUser
    }

    return this.value.user
  }
}
